import vClickOutside from "v-click-outside";
import { logout } from "@/components/navigation/topNavigation.js";
import { mapGetters } from "vuex";
import { dialogHelper } from "@/components/mixin/dialogHelper";
import userStatusHelper from "../../../../components/mixin/userStatusHelper";

export default {
  mixins: [dialogHelper, userStatusHelper],
  directives: {
    clickOutside: vClickOutside.directive,
  },

  computed: {
    notificationCount() {
      return this.$store.getters.notificationState;
    },
    draftCount() {
      return this.$store.getters.draftCount;
    },
    ...mapGetters({
      user: "userState",
      draftCount: "draftCount",
    }),
    filteredLinks() {
      return this.links.filter((link) => link.excludeFromNav === undefined || link.excludeFromNav);
    },
  },
  data() {
    return {
      isAsideVisible: true,
      links: [
        {
          access: ["BRAND"],
          name: "Brand Page",
          path: "brands/my-brand-page",
          supportedRoutes: ["my-brand-page"],
          isExpanded: false,
        },
        {
          access: ["RETAILER"],
          name: "Profile",
          path: "/retailer",
          supportedRoutes: ["retailer-profile"],
          isExpanded: false,
          linkOut: true,
        },

        {
          access: ["ADMIN", "BRAND", "PRODUCT_BUILDER"],
          name: "Products",
          isExpanded: false,
          children: [
            {
              access: ["ADMIN", "BRAND", "PRODUCT_BUILDER"],
              name: "Products",
              path: "products",
              supportedRoutes: ["dashboardProducts", "createProduct", "editProduct"],
            },
            {
              access: ["BRAND", "PRODUCT_BUILDER", "ADMIN"],
              name: "For Review",
              path: "for-review",
              supportedRoutes: ["dashboardDrafts"],
            },
            {
              access: ["ADMIN"],
              name: "Collections",
              path: "collections",
              supportedRoutes: ["dashboardCollections", "editCollection", "editProduct"],
            },
            // {
            //     access: ['ADMIN'],
            //     name: 'Categories',
            //     path: 'categories',
            //     supportedRoutes: ['dashboardCategories']
            // }
          ],
        },
        {
          access: ["ADMIN", "BRAND"],
          name: "Orders",
          isExpanded: false,
          children: [
            {
              access: ["ADMIN", "BRAND"],
              name: "Orders",
              path: "orders",
              supportedRoutes: ["orders", "suborderDetails", "orderDetails"],
            },
            {
              access: ["ADMIN"],
              name: "Custom Assortments",
              path: "custom-assortments",
              supportedRoutes: ["customAssortments"],
            },
            {
              access: ["ADMIN", "RETAILER"],
              name: "Invoices",
              path: "invoices",
              supportedRoutes: ["invoices"],
            },
            {
              access: ["ADMIN", "BRAND"],
              name: "Payments",
              path: "payments",
              supportedRoutes: ["payments", "paymentDetails"],
            },
          ],
        },
        {
          access: ["RETAILER"],
          name: "Orders",
          isExpanded: false,
          children: [
            {
              access: ["RETAILER"],
              name: "Orders",
              path: "retailer/orders",
              supportedRoutes: ["ordersRetailer", "suborderDetails", "orderDetails"],
            },
            {
              access: ["RETAILER"],
              name: "Custom Assortments",
              path: "custom-assortments",
              supportedRoutes: ["customAssortments"],
            },
            {
              access: ["RETAILER"],
              name: "Invoices",
              path: "invoices",
              supportedRoutes: ["invoices"],
            },
          ],
        },
        {
          access: ["ADMIN"],
          name: "Directory",
          isExpanded: false,
          children: [
            {
              access: ["ADMIN"],
              name: "Brands",
              path: "brands",
              supportedRoutes: ["dashboardBrands", "createBrand", "editBrand"],
            },
            {
              access: ["ADMIN"],
              name: "Retailers",
              path: "retailers",
              supportedRoutes: ["dashboardRetailers", "Retailer Details"],
            },
          ],
        },
        {
          access: ["ADMIN"],
          name: "Applications",
          isExpanded: false,
          children: [
            {
              access: ["ADMIN"],
              name: "Brands",
              path: "applications/brands",
              supportedRoutes: ["dashboardBrandApplications"],
            },
            {
              access: ["ADMIN"],
              name: "Retailers",
              path: "applications/retailers",
              supportedRoutes: ["dashboardRetailerApplications"],
            },
          ],
        },
        {
          access: ["RETAILER"],
          name: "Favorites",
          path: "favorites",
          supportedRoutes: [
            "dashboardFavorites",
            "dashboardFavoritesProduct",
            "dashboardFavoritesBrand",
            "dashboardFavoritesRecommendation",
          ],
        },
        {
          access: ["ADMIN", "BRAND"],
          name: "Posts",
          path: "posts",
          supportedRoutes: ["dashboardPosts"],
        },
        {
          access: ["RETAILER", "BRAND"],
          name: "Messages",
          path: "messages",
          checkApprovedState: true,
          checkUserState: true,
          supportedRoutes: ["dashboardMessages"],
        },
        {
          access: ["ADMIN", "BRAND"],
          name: "Referrals",
          path: "referrals",
          supportedRoutes: ["dashboardReferrals", "dashboardCreateReferral"],
        },
        {
          access: ["ADMIN"],
          name: "Content Management",
          path: "content-management",
          supportedRoutes: ["dashboardHomepage"],
        },
        {
          access: ["RETAILER"],
          name: "Account Settings",
          path: "profile",
          supportedRoutes: ["dashboardProfile", "dashboardPassword"],
          isExpanded: false,
          children: [
            {
              access: ["RETAILER"],
              name: "Profile",
              path: "profile",
              supportedRoutes: ["dashboardProfile"],
            },
            {
              access: ["RETAILER"],
              name: "Password",
              path: "password",
              supportedRoutes: ["dashboardPassword"],
            },
            {
              access: ["RETAILER"],
              name: "Addresses",
              path: "addresses",
              supportedRoutes: ["dashboardAddresses", "dashboardCreateAddress", "dashboardEditAddress"],
            },
            {
              access: ["RETAILER"],
              name: "Payment options",
              path: "payment-options",
              supportedRoutes: ["dashboardPaymentInfo"],
            },
          ],
        },
        {
          access: ["ADMIN"],
          name: "Promo codes",
          path: "admin-promo-codes",
          supportedRoutes: ["dashboardAdminPromoCodes"],
        },
        {
          access: ["BRAND"],
          name: "Promo codes",
          path: "brand-promo-codes",
          supportedRoutes: ["dashboardBrandPromoCodes"],
        },
      ],
    };
  },

  beforeMount() {
    this.setActiveSidebarItem();
    this.toggleAssideMenu();
  },

  mounted() {
    this.$eventBus.$on("toggle-dashboard-sidebar", this.toggleSidebarCallback);
    window.addEventListener("resize", this.toggleAssideMenu);
    this.$store.dispatch("getDraftCount");
  },

  beforeDestroy() {
    this.$eventBus.$off("toggle-dashboard-sidebar", this.toggleSidebarCallback);
    window.removeEventListener("resize", this.toggleAssideMenu);
  },

  methods: {
    setActiveSidebarItem,
    toggleSidebarItem,
    collapseSidebarItems,
    redirect,
    closeSidebar,
    toggleSidebarCallback,
    toggleAssideMenu,
    handleParentLinkClick,
    logout,
    getMenuCount,
    hasMenuAccess,
    navigateToChild,
    preventNavigationBasedOnState,
  },
};

function redirect(path) {
  this.collapseSidebarItems();
  this.toggleAssideMenu();

  this.$router.push(path);
}

function toggleSidebarItem(targetIndex) {
  this.links.forEach((item, index) => {
    if (index !== targetIndex) {
      item.isExpanded = false;
    }
  });

  this.$set(this.links[targetIndex], "isExpanded", !this.links[targetIndex].isExpanded);
}
function handleParentLinkClick(link, index) {
  this.$store.dispatch("navigation/hideSideBar");
  const routePrefix = link.linkOut ? "" : "/dashboard/";
  if (link.isExpanded === false && link.children) {
    this.toggleSidebarItem(index);
    this.$router.push(routePrefix + link.children[0].path);
  } else {
    if (link.children) {
      this.toggleSidebarItem(index);
    } else if (!this.preventNavigationBasedOnState(link)) {
      this.redirect(routePrefix + link.path);
    }
  }
}
function navigateToChild(menuItem) {
  if (!menuItem.path) {
    return;
  }
  this.$store.dispatch("navigation/hideSideBar");
  this.$router.push("/dashboard/" + menuItem.path);
  this.toggleAssideMenu();
}

function collapseSidebarItems() {
  this.links.forEach((item) => {
    item.isExpanded = false;
  });
}

function setActiveSidebarItem() {
  this.links.forEach((link) => {
    // if link doesn't contain children
    if (!link.children && link.supportedRoutes && link.supportedRoutes.includes(this.$route.name)) {
      link.isExpanded = true;
    }

    if (link.children) {
      link.children.forEach((child) => {
        if (child.supportedRoutes.includes(this.$route.name)) {
          link.isExpanded = true;
        }
      });
    }
  });
}

function toggleSidebarCallback() {
  this.isAsideVisible = !this.isAsideVisible;
}

function closeSidebar() {
  this.isAsideVisible = false;
}

function toggleAssideMenu() {
  let width = document.documentElement.clientWidth;
  this.isAsideVisible = width >= 993;
}

function hasMenuAccess(link) {
  return this.user && link.access.indexOf(this.user.role) !== -1;
}

function preventNavigationBasedOnState(menuItem) {
  if (!menuItem.checkUserState) {
    return false;
  }
  if (menuItem.path === "messages" && this.user.role === "BRAND") {
    return false;
  }
  if (menuItem.path === "messages" && (this.isRetailerSuspended || !this.isRetailerApproved)) {
    this.showMessageWarningToSuspendedOrDeclinedRetailers();
    return true;
  }
}

function getMenuCount(menuKey) {
  if (menuKey === "for-review") {
    return this.draftCount;
  }
}
